import * as React from 'react';
import { DomainEntityConfiguration } from '@web-config-app/core';
import { useConfigApp } from '../use-config-app/use-config-app';

/**
 * Custom hook to retrieve a map of all entities from the configuration app.
 *
 * @returns A map keyed by entity type string (e.g. 'config-campaign') to entity configuration.
 */
export const useEntities = (): Map<string, DomainEntityConfiguration> => {
  const { entityConfigs } = useConfigApp();

  return React.useMemo(() => {
    const entityMap = new Map<string, DomainEntityConfiguration>();

    Object.values(entityConfigs).forEach(
      (entity: DomainEntityConfiguration) => {
        entityMap.set(entity.type, entity);
      },
    );

    return entityMap;
  }, [entityConfigs]);
};
